export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20media%20company%20office%20with%20warm%20coral%20and%20gold%20ambient%20lighting%2C%20creative%20workspace%20with%20large%20screens%20displaying%20abstract%20visuals%2C%20editorial%20style%20photography%20with%20soft%20focus%20background%2C%20no%20people&width=960&height=720&seq=about-01&orientation=landscape"
                alt="吃瓜视频 - 关于我们"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-4">关于吃瓜视频</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              吃瓜视频是国内领先的国产吃瓜视频内容聚合平台，致力于为广大用户提供最新、最全、最热的娱乐资讯。
              我们汇聚了来自全国各地的优质娱乐内容，涵盖明星动态、综艺片段、影视解说、网红八卦等多个领域。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              平台每日更新海量国产吃瓜视频，专业编辑团队7×24小时追踪国内热点事件，确保用户第一时间获取最新娱乐资讯。
              我们坚持以内容质量为核心，为用户打造一个干净、纯粹、高效的娱乐内容消费平台。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              自上线以来，吃瓜视频凭借快速的更新频率和优质的内容筛选，已收获数百万用户的认可与喜爱。
              未来我们将继续深耕国产吃瓜视频领域，为更多用户带来精彩的娱乐内容体验。
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-100/70">
                <i className="ri-team-line text-primary-500"></i>
                <span className="text-sm font-medium text-primary-700">50+ 专业编辑</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-100/70">
                <i className="ri-video-line text-accent-500"></i>
                <span className="text-sm font-medium text-accent-700">10万+ 日更内容</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-100/70">
                <i className="ri-user-heart-line text-secondary-500"></i>
                <span className="text-sm font-medium text-secondary-700">百万级用户</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}